import { FC } from 'react';

import { Icon } from '@shared/components/icons';

export const GiftDepositInfoBox: FC = function GiftDepositInfoBox() {
  const { CashAccount } = Icon();

  return (
    <div className="p-4 py-2 pb-4 theme-bg-1">
      <div className="center-box gap-2">
        <CashAccount />
        <p className="font-bold">답례품 구매용 입금계좌</p>
      </div>

      <div className="mt-4 space-y-4">
        <div className="center-box gap-6 font-bold">
          <div className="center-box flex-col items-center break-keep">
            <p className="">입금계좌</p>
            <p className="text-14 theme-text-main">(주)가온프라임</p>
          </div>
          <div className="break-keep text-base">
            <p className="theme-text-main">기업은행</p>
            <p>137-115848-04-019</p>
          </div>
        </div>
      </div>
    </div>
  );
};
